<template>
    <div>
        <div class="col-12 mb-4">
            <h4 class="mb-3">Your Notifications</h4>
            <p class="alert alert-primary">You will receive notification email whenever the event happens in the building (once per hour).</p>
            <p class="alert alert-info">Notification will be sent to: <span class="badge badge-primary" v-if="user">{{user.email}}</span></p>

            <div class="list-group" v-if="!response.isLoading">
                <div class="list-group-item list-group-item-action" v-for="(building, buildingIndex) in sortedBuildings">
                    <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1" v-bind:title="building.fullAddress">{{building.fullAddress}}</h5>
                    </div>
                    <p class="d-block buildingCard-checkbox" v-if="building.notificationsFailed !== undefined">
                        Permission denied, please contact building manager for details.
                    </p>
                    <div v-else>
                        <form v-on:submit.prevent>
                            <label class="d-block buildingCard-checkbox"
                                   v-for="(userNotification, userNotificationIndex) in building.userNotifications.list"
                                   v-bind:key="userNotification.notification_id"
                            >
                                <input class="buildingCard-checkbox-input"
                                       type="checkbox"
                                       v-on:change="updateUserNotifications(building, userNotification)"
                                       v-bind:name="'notification-' + userNotification.notification_id"
                                       v-bind:value="userNotification.notification_id"
                                       v-model="userNotification.opt_in"/>
                                <span class="buildingCard-checkbox-container"><i class="fas fa-check buildingCard-checkbox-check ml-auto" v-bind:class="{'invisible': !userNotification.opt_in}"></i></span>
                                {{userNotification.desc}} -- {{userNotification.opt_in}}
                                <span v-if="building.userNotifications.saving.indexOf(userNotification.notification_id) > -1" class="spinner-border spinner-border-sm text-danger" role="status">
                                    <span class="sr-only">saving...</span>
                                </span>
                                <i v-if="building.userNotifications.saved.indexOf(userNotification.notification_id) > -1"  class="far fa-check-circle text-success"></i>
                            </label>
                        </form>
                    </div>
                </div>
            </div>
            <div v-else>
                <div v-if="response.isLoading" class="loading-bar-static">
                    <div class="loading-bar-static-fg" v-bind:style="{width: `${Math.round(response.loaded * 100 / buildingList.length)}%`}"></div>
                    <div class="loading-bar-static-text">{{`${buildingList.length ? Math.round(response.loaded * 100 / buildingList.length) : 0}%`}}</div>
                </div>
                <h4 v-else class="mb-3">No Notifications available</h4>
            </div>
        </div>
    </div>
</template>
<script>
  import Tools from '@/app-model/tools.js';
  import Building from '@/app-model/building.js';
  import Notification from '@/app-model/notification.js';

  export default {
    components: {},
    data() {
      return {
        buildings: [],
        response: {
          loaded: 0,
          isLoading: true,
          isSuccess: false
        },
        dataToPassToModal: {
          device_fingerprint: '',
          showModal: false,
        },
        ajaxPoolSize: 10,
      }
    },
    computed: {
      tools: function () {
        return new Tools
      },
      buildingModel: function () {
        return new Building;
      },
      notification: function () {
        return new Notification;
      },
      user: function () {
        return this.$store.getters.firebaseUser;
      },
      buildingList: function () {
        return this.$store.getters.buildings;
      },
      sortedBuildings: function () {
        let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});

        return this.buildings.sort((a, b) => {
          return collator.compare(a.fullAddress, b.fullAddress);
        });
      },
    },
    created() {
      this.response.isLoading = true;
      if (!this.buildingList.length) {
        this.buildingModel.loadBuildings({store: this.$store}).then(response => {
          this.loadPage();
        });
      }
      else {
        this.loadPage();
      }
    },
    methods: {
      loadPage: function () {
        if (this.buildingList.length == 0) {
          this.response.isSuccess = false;
          return;
        }

        for (let building of this.buildingList) {
          this.buildingModel.setStatus(
            building,
            {
              key: undefined,
              parking: undefined,
              toilet: undefined,
              note: undefined
            }
          );
        }

        this.tools.asyncPool(this.ajaxPoolSize, this.buildingList, this.loadNotifications)
          .then(response => {
            this.response.isLoading = false;
          });

        this.response.isSuccess = true;
      },
      loadNotifications: function (buildingIndex, building) {
        this.response.loaded ++;
        building = Object.assign({
          userNotifications: {
            loading: false,
            saving: [],
            buildingId: undefined,
            saved: [],
            list: []
          },
          userNotificationsFailed: false
        }, building);
        return this.notification.loadNotifications(this.$store, building.id)
          .then(response => {
            if (response.status === 200) {
              building = Object.assign(building, {'notifications': response.data.data});
              return this.notification.loadUserNotifications(this.$store, building.id)
                .then(response => {
                  if (response.status === 200) {
                    let data = [];
                    for (let i = 0; i < building.notifications.length; i++) {
                      let {id: notification_id, default_opt_in: opt_in, desc} = building.notifications[i],
                        index = response.data.data.findIndex(el => el.notification_id === notification_id),
                        notification = {};
                      if (index < 0) {
                        notification = {notification_id, opt_in};
                      }
                      else {
                        notification = Object.assign({}, response.data.data[index]);
                      }
                      notification['opt_in'] = !!notification['opt_in'];
                      building.userNotifications.list.push(Object.assign({}, notification, {desc}));
                    }
                  }
                  else {
                    building.userNotificationsFailed = true;
                  }

                  return response;
                });
            }
            else {
              building.userNotificationsFailed = true;
              return response;
            }
          }).then(response => {
            this.buildings.push(building);
          });
      },
      updateUserNotifications: function (building, userNotification) {
        let method = userNotification.opt_in ? 'PUT' : 'DELETE',
          notificationId = userNotification.notification_id;

        building.userNotifications.saved = building.userNotifications.saved.filter(el => el !== notificationId);
        building.userNotifications.saving.push(notificationId);
        this.notification.updateUserNotifications(this.$store, method, building.id, notificationId)
          .then(response => {
            building.userNotifications.saving = building.userNotifications.saving.filter(el => el !== notificationId);
            if (response.status === 200) {
              building.userNotifications.saved.push(notificationId);
            }
            setTimeout(function () {
              building.userNotifications.saved = building.userNotifications.saved.filter(el => el !== notificationId);
            }, 1000);
          });
      },
    }
  }
</script>
<style lang="scss" scoped>
    @import "@/../sass/_building_card.scss";
</style>